module.exports = __webpack_public_path__ + "assets/images/mci-login-background.png";